<aside>
  <nav>
    <ul>
      <li *ngIf="!isSafeGis && isGpaUser || isGpaGeomonitoringAdmin">
        <div
          class="arrow"
          (click)="toggleArrowSide()"
          [ngStyle]="{ left: isSidebarPinned ? '22px' : '208px' }"
        >
          <svg
            [style.transform]="rotationArrow()"
            width="16"
            height="15"
            viewBox="0 0 16 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.8647 0.00176811C15.1295 0.0013113 15.3861 0.0826864 15.59 0.231768C15.7048 0.315717 15.7996 0.418818 15.8692 0.535166C15.9387 0.651513 15.9815 0.778819 15.9952 0.909796C16.0089 1.04077 15.9932 1.17284 15.9489 1.29845C15.9047 1.42405 15.8328 1.54072 15.7374 1.64177L10.6603 7.00177L15.556 12.3718C15.6502 12.4741 15.7205 12.5918 15.7629 12.7181C15.8053 12.8444 15.819 12.9769 15.8032 13.108C15.7874 13.239 15.7424 13.366 15.6708 13.4816C15.5992 13.5972 15.5025 13.6992 15.386 13.7818C15.2688 13.8728 15.1315 13.9415 14.9827 13.9835C14.834 14.0255 14.677 14.0399 14.5216 14.0258C14.3663 14.0117 14.2159 13.9694 14.0799 13.9016C13.9439 13.8338 13.8253 13.7419 13.7315 13.6318L8.2578 7.63177C8.09112 7.45284 8 7.22839 8 6.99677C8 6.76514 8.09112 6.5407 8.2578 6.36177L13.9241 0.361769C14.0378 0.240751 14.1822 0.145087 14.3457 0.0825386C14.5091 0.01999 14.6869 -0.0076828 14.8647 0.00176811Z"
              fill="url(#paint0_linear_341_122)"
            />
            <path
              d="M6.86474 0.00176811C7.12953 0.0013113 7.38614 0.0826864 7.59003 0.231768C7.70478 0.315717 7.79964 0.418818 7.86917 0.535166C7.93869 0.651513 7.98153 0.778819 7.99521 0.909796C8.0089 1.04077 7.99317 1.17284 7.94892 1.29845C7.90467 1.42405 7.83278 1.54072 7.73736 1.64177L2.66033 7.00177L7.55603 12.3718C7.65017 12.4741 7.72047 12.5918 7.76289 12.7181C7.80531 12.8444 7.81901 12.9769 7.80322 13.108C7.78742 13.239 7.74243 13.366 7.67084 13.4816C7.59925 13.5972 7.50246 13.6992 7.38604 13.7818C7.26879 13.8728 7.13147 13.9415 6.98272 13.9835C6.83396 14.0255 6.67698 14.0399 6.52162 14.0258C6.36625 14.0117 6.21587 13.9694 6.0799 13.9016C5.94392 13.8338 5.8253 13.7419 5.73147 13.6318L0.257804 7.63177C0.0911217 7.45284 0 7.22839 0 6.99677C0 6.76514 0.0911217 6.5407 0.257804 6.36177L5.92413 0.361769C6.03782 0.240751 6.18223 0.145087 6.34566 0.0825386C6.50909 0.01999 6.68692 -0.0076828 6.86474 0.00176811Z"
              fill="url(#paint1_linear_341_122)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_341_122"
                x1="15.8251"
                y1="0.20834"
                x2="0.690979"
                y2="14.7237"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#487513" />
                <stop offset="1" stop-color="#BADF69" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_341_122"
                x1="15.8251"
                y1="0.20834"
                x2="0.690979"
                y2="14.7237"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#487513" />
                <stop offset="1" stop-color="#BADF69" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </li>
      <li *ngIf="(!isSafeGis && isGpaUser || isGpaGeomonitoringAdmin) && !isNicePlanet">
        <a
          routerLink="/home"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="icon">
            <svg
              width="26"
              height="24"
              viewBox="0 0 26 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24.8809 11.8086L13.618 0.553933C13.5369 0.472678 13.4406 0.408214 13.3345 0.364231C13.2285 0.320247 13.1148 0.297607 13 0.297607C12.8852 0.297607 12.7716 0.320247 12.6655 0.364231C12.5595 0.408214 12.4632 0.472678 12.3821 0.553933L1.11917 11.8086C0.79104 12.1367 0.605103 12.5824 0.605103 13.0473C0.605103 14.0125 1.38987 14.7973 2.3551 14.7973H3.54182V22.8282C3.54182 23.3121 3.93284 23.7032 4.41682 23.7032H11.25V17.5782H14.3125V23.7032H21.5832C22.0672 23.7032 22.4582 23.3121 22.4582 22.8282V14.7973H23.6449C24.1098 14.7973 24.5555 14.6141 24.8836 14.2832C25.5645 13.5996 25.5645 12.4922 24.8809 11.8086Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Home</span>
        </a>
      </li>

      <li
        *ngIf="!isSafeGis && !isCarrefour && !isGpaUserProvider && !isAuditing && !isNicePlanet"
      >
        <a
          routerLink="/sumario"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="icon">
            <svg
              width="25"
              height="26"
              viewBox="0 0 25 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.56579 26C1.8602 26 1.25638 25.7456 0.754342 25.2369C0.251447 24.7273 0 24.115 0 23.4V2.6C0 1.885 0.251447 1.2727 0.754342 0.7631C1.25638 0.254367 1.8602 0 2.56579 0H12.8289L20.5263 7.8V11.83L10.2632 22.1975V26H2.56579ZM12.8289 26V23.2375L19.4359 16.51L22.1941 19.24L15.5551 26H12.8289ZM23.1242 18.33L20.398 15.5675L21.2961 14.6575C21.5526 14.3975 21.8627 14.2675 22.2262 14.2675C22.5896 14.2675 22.889 14.3975 23.1242 14.6575L24.0222 15.6C24.2574 15.86 24.375 16.1685 24.375 16.5256C24.375 16.8835 24.2574 17.1817 24.0222 17.42L23.1242 18.33ZM11.5461 9.1H17.9605L11.5461 2.6V9.1Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Sumário</span>
        </a>
      </li>
      <li *ngIf="(!isSafeGis && isGpaUser && !isCarrefour && !isAuditing) || isNicePlanet">
        <a routerLink="/relatorios" [routerLinkActive]="['active']">
          <span class="icon">
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_341_641)">
                <path d="M28 27H3V2H5.41934V24.5807H28V27Z" fill="white" />
                <path
                  d="M10.258 14.0968H7.83862V22.1613H10.258V14.0968Z"
                  fill="white"
                />
                <path
                  d="M15.0966 7.64514H12.6772V22.1613H15.0966V7.64514Z"
                  fill="white"
                />
                <path
                  d="M19.9354 14.0968H17.5161V22.1613H19.9354V14.0968Z"
                  fill="white"
                />
                <path
                  d="M24.7741 7.64514H22.3547V22.1613H24.7741V7.64514Z"
                  fill="white"
                />
                <path d="M28 24.5807H16.3064V27H28V24.5807Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_341_641">
                  <rect
                    width="25"
                    height="25"
                    fill="white"
                    transform="translate(3 2)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="item">Relatórios</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUser && !isAuditing && !isNicePlanet">
        <a routerLink="/dashboards" [routerLinkActive]="['active']">
          <span class="icon"
            ><svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_341_621)">
                <path
                  d="M22.1502 7.52515L18.0264 8.25183L19.6537 9.39095L17.3604 12.6671L10.8177 8.08719L7.02319 14.1582L8.67683 15.1917L11.3824 10.8628L17.8396 15.3829L21.2512 10.5092L22.8783 11.6483L22.1502 7.52515Z"
                  fill="white"
                />
                <path
                  d="M17.5999 25.4V23.45H12.3999V25.4H9.1499V27.35H20.8499V25.4H17.5999Z"
                  fill="white"
                />
                <path
                  d="M2 2.65002V21.5H28V2.65002H2ZM26.05 17.6H3.95V4.60002H26.05V17.6Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_341_621">
                  <rect
                    width="26"
                    height="26"
                    fill="white"
                    transform="translate(2 2)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="item">Indic./DashBoards</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUser && !isCarrefour && !isAuditing && !isNicePlanet">
        <a routerLink="/manuais" [routerLinkActive]="['active']">
          <span class="icon"
            ><svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.96556 10.4482H23.5173L28.4829 15.4138H2L6.96556 10.4482Z"
                fill="white"
              />
              <path
                d="M7.79313 12.1034H22.6897L26.8277 16.2413C26.8277 16.2413 26.4884 20.3793 25.89 20.3793H4.43648C3.93666 20.3793 3.65527 16.2413 3.65527 16.2413L7.79313 12.1034Z"
                fill="#001539"
              />
              <path
                d="M6.96556 3H23.5173C23.975 3 24.3449 3.37078 24.3449 3.82762V17.8966C24.3449 18.3534 23.975 18.7242 23.5173 18.7242H6.96556C6.50786 18.7242 6.13794 18.3534 6.13794 17.8966V3.82754C6.13794 3.37078 6.50786 3 6.96556 3Z"
                fill="white"
              />
              <path
                d="M9.44823 7.13791H21.0344C21.4921 7.13791 21.862 6.76713 21.862 6.31029C21.862 5.85345 21.4921 5.48267 21.0344 5.48267H9.44823C8.99053 5.48267 8.62061 5.85345 8.62061 6.31029C8.62061 6.76713 8.99062 7.13791 9.44823 7.13791ZM21.0345 8.79307H9.44823C8.99053 8.79307 8.62061 9.16385 8.62061 9.62069C8.62061 10.0775 8.99053 10.4483 9.44823 10.4483H21.0344C21.4921 10.4483 21.862 10.0784 21.862 9.62069C21.862 9.16299 21.4921 8.79307 21.0345 8.79307ZM21.0345 12.1034H9.44823C8.99053 12.1034 8.62061 12.4742 8.62061 12.931C8.62061 13.3878 8.99053 13.7586 9.44823 13.7586H21.0344C21.4921 13.7586 21.862 13.3878 21.862 12.931C21.862 12.4742 21.4921 12.1034 21.0345 12.1034Z"
                fill="#001539"
              />
              <path
                d="M20.2069 15.4138V17.069C20.2069 17.9834 19.4654 18.7241 18.5517 18.7241H11.931C11.0174 18.7241 10.2759 17.9827 10.2759 17.069V15.4138H2V25.3449C2 26.2585 2.74148 27 3.65516 27H26.8276C27.7413 27 28.4828 26.2585 28.4828 25.3449V15.4138H20.2069Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Manuais</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUser && !isAuditing && !isNicePlanet">
        <a
          routerLink="/produtos"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="icon"
            ><svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25 7L13 1L1 7V19L13 25L25 19V7Z"
                stroke="white"
                stroke-width="2"
                stroke-linejoin="round"
              />
              <path
                d="M1 7L13 13M13 25V13M25 7L13 13M19 4L7 10"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="item">Produtos</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUser && !isAuditing && !isNicePlanet">
        <a
          routerLink="/fornecedores"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="icon">
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.6412 10.1305L13.4412 7.05388C13.3076 6.97475 13.1552 6.93308 13 6.93323C12.8447 6.93338 12.6924 6.97536 12.5589 7.05475L7.359 10.1314C7.22935 10.2079 7.1219 10.3168 7.04727 10.4475C6.97264 10.5783 6.93342 10.7262 6.93347 10.8767V16.8567C6.93347 17.1635 7.09554 17.4468 7.359 17.602L12.5589 20.6786C12.6922 20.7586 12.8447 20.8008 13.0001 20.8008C13.1555 20.8008 13.308 20.7586 13.4412 20.6786L18.6412 17.602C18.7708 17.5255 18.8783 17.4165 18.9529 17.2858C19.0275 17.1551 19.0667 17.0072 19.0667 16.8567V10.8767C19.0667 10.7261 19.0275 10.578 18.9529 10.4472C18.8783 10.3163 18.7708 10.2072 18.6412 10.1305ZM17.3334 16.3627L13.0001 18.9262L8.66679 16.3627V11.3707L13.0001 8.80713L17.3334 11.3707V16.3627Z"
                fill="white"
              />
              <path
                d="M4.33345 16.626V8.72731L9.70673 5.55187L8.82534 4.05949L3.02567 7.48712C2.89601 7.56379 2.78857 7.67294 2.71395 7.80379C2.63933 7.93464 2.6001 8.08268 2.60014 8.23331V16.626C2.09468 16.8042 1.65673 17.1344 1.34639 17.5714C1.03606 18.0083 0.868539 18.5306 0.866821 19.0665C0.866821 20.5 2.03334 21.6665 3.4668 21.6665C4.90025 21.6665 6.06677 20.5 6.06677 19.0665C6.06505 18.5306 5.89753 18.0083 5.5872 17.5714C5.27686 17.1344 4.83892 16.8042 4.33345 16.626ZM3.4668 19.9332C3.24365 19.9232 3.03295 19.8275 2.87857 19.6661C2.7242 19.5047 2.63804 19.2899 2.63804 19.0665C2.63804 18.8432 2.7242 18.6284 2.87857 18.467C3.03295 18.3055 3.24365 18.2099 3.4668 18.1999C3.68994 18.2099 3.90064 18.3055 4.05502 18.467C4.20939 18.6284 4.29555 18.8432 4.29555 19.0665C4.29555 19.2899 4.20939 19.5047 4.05502 19.6661C3.90064 19.8275 3.68994 19.9232 3.4668 19.9332ZM22.5333 16.4666C21.0998 16.4666 19.9333 17.6331 19.9333 19.0665C19.9333 19.3725 19.9957 19.6619 20.0936 19.9349L13 24.1261L7.44996 20.8467L6.56856 22.339L12.5589 25.8785C12.6923 25.9579 12.8447 25.9998 12.9999 26C13.1552 26.0001 13.3076 25.9585 13.4412 25.8793L21.2064 21.2904C21.5964 21.5235 22.0471 21.6665 22.5333 21.6665C23.9667 21.6665 25.1332 20.5 25.1332 19.0665C25.1332 17.6331 23.9667 16.4666 22.5333 16.4666ZM22.5333 19.9332C22.3101 19.9232 22.0994 19.8275 21.945 19.6661C21.7907 19.5047 21.7045 19.2899 21.7045 19.0665C21.7045 18.8432 21.7907 18.6284 21.945 18.467C22.0994 18.3055 22.3101 18.2099 22.5333 18.1999C22.7564 18.2099 22.9671 18.3055 23.1215 18.467C23.2759 18.6284 23.362 18.8432 23.362 19.0665C23.362 19.2899 23.2759 19.5047 23.1215 19.6661C22.9671 19.8275 22.7564 19.9232 22.5333 19.9332ZM13 5.20001C13.6336 5.20001 14.2064 4.96341 14.658 4.58641L21.6666 8.72817V14.7332H23.3999V8.23331C23.4 8.08268 23.3607 7.93464 23.2861 7.80379C23.2115 7.67294 23.1041 7.56379 22.9744 7.48712L15.5497 3.1001C15.5809 2.93803 15.6 2.77163 15.6 2.60003C15.6 1.16658 14.4335 6.10352e-05 13 6.10352e-05C11.5666 6.10352e-05 10.4001 1.16658 10.4001 2.60003C10.4001 4.03349 11.5666 5.20001 13 5.20001ZM13 1.73338C13.1717 1.73321 13.3395 1.78396 13.4823 1.87922C13.6251 1.97448 13.7365 2.10996 13.8022 2.26851C13.868 2.42707 13.8852 2.60157 13.8518 2.76993C13.8184 2.9383 13.7357 3.09296 13.6143 3.21433C13.493 3.33571 13.3383 3.41835 13.1699 3.4518C13.0016 3.48524 12.8271 3.46799 12.6685 3.40222C12.51 3.33646 12.3745 3.22513 12.2792 3.08233C12.184 2.93954 12.1332 2.77169 12.1334 2.60003C12.1334 2.12164 12.5225 1.73338 13 1.73338Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Fornecedores</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUser && !isAuditing && !isNicePlanet">
        <a routerLink="/ranking">
          <span class="icon"
            ><svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.26434 12.0436C1.26434 11.8204 1.31893 11.5918 1.42801 11.4302C1.53708 11.2685 1.68688 11.1903 1.87741 11.1903C2.09049 11.1903 2.25034 11.2543 2.35698 11.3795C2.46347 11.505 2.51684 11.6737 2.51684 11.8842C2.51684 12.0321 2.46413 12.2067 2.35891 12.4073C2.25364 12.6079 2.06891 12.8362 1.84567 13.0919L0.0650106 14.9424V15.7273H3.86033V14.8343H1.80216L1.79078 14.7905L2.53177 13.9864C3.01322 13.4625 3.34339 13.0622 3.5228 12.7964C3.70195 12.5306 3.79158 12.2221 3.79158 11.8762C3.79158 11.3622 3.62289 10.956 3.28581 10.66C2.94857 10.3643 2.47906 10.2157 1.87741 10.2157C1.31081 10.2157 0.855712 10.3915 0.512233 10.7437C0.168755 11.0959 0.00321093 11.5198 0.0158045 12.0263L0.0233707 12.0435H1.26434V12.0436Z"
                fill="white"
              />
              <path
                d="M1.29281 6.46237H0.0649414V7.46701H3.86027V6.46237H2.63235V1.93164L0.0649414 2.31524V3.22517H1.29281V6.46237Z"
                fill="white"
              />
              <path
                d="M3.01674 21.1825C3.27491 21.0647 3.48123 20.9011 3.6354 20.6918C3.78967 20.4825 3.8667 20.2536 3.8667 20.0055C3.8667 19.5066 3.68867 19.1211 3.3327 18.8491C2.97672 18.5769 2.50162 18.441 1.90734 18.441C1.39588 18.441 0.960846 18.5764 0.602337 18.8472C0.243827 19.118 0.0718851 19.4911 0.0869668 19.9273L0.0945331 19.9694H1.32814C1.32814 19.7461 1.39065 19.6766 1.51613 19.5813C1.64151 19.4859 1.78694 19.4287 1.95238 19.4287C2.16302 19.4287 2.32344 19.4827 2.43383 19.6006C2.54413 19.7184 2.59927 19.8613 2.59927 20.0343C2.59927 20.2524 2.53788 20.4333 2.41509 20.5562C2.29221 20.6791 2.11671 20.7507 1.88855 20.7507H1.29275V21.6438H1.8885C2.14179 21.6438 2.33791 21.7186 2.4771 21.8401C2.61629 21.9618 2.68585 22.1625 2.68585 22.4282C2.68585 22.6188 2.61933 22.7802 2.48659 22.9056C2.35365 23.031 2.17561 23.0953 1.95243 23.0953C1.75688 23.0953 1.59088 23.011 1.45413 22.892C1.31737 22.773 1.24918 22.6484 1.24918 22.4252H0.00805416L0.000589445 22.4734C-0.0119025 22.9849 0.174157 23.3883 0.559072 23.6578C0.943987 23.9272 1.39339 24.0684 1.90729 24.0684C2.50406 24.0684 2.99419 23.9282 3.37784 23.6411C3.76148 23.3541 3.95318 22.9613 3.95318 22.4598C3.95318 22.154 3.87056 21.8922 3.70502 21.6728C3.53947 21.4532 3.3101 21.2904 3.01674 21.1825Z"
                fill="white"
              />
              <path
                d="M25.9618 18.4062H7.54346V22.0899H25.9618V18.4062Z"
                fill="white"
              />
              <path
                d="M25.9618 11.1505H7.54346V14.8342H25.9618V11.1505Z"
                fill="white"
              />
              <path
                d="M25.9618 3.67163H7.54346V7.35529H25.9618V3.67163Z"
                fill="white"
              />
              <path
                d="M26.0002 18.4062H13.1631V22.0899H26.0002V18.4062Z"
                fill="white"
              />
              <path
                d="M26.0002 11.1505H13.1631V14.8342H26.0002V11.1505Z"
                fill="white"
              />
              <path
                d="M26.0002 3.67163H13.1631V7.35529H26.0002V3.67163Z"
                fill="white"
              /> 
              </svg>
        </span>
          <span class="item">Ranking</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUser && !isAuditing && !isNicePlanet">
        <a
          routerLink="/integracao"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.82627 27.0747C9.17967 27.0747 10.2802 26.1065 10.2802 24.9142C10.2802 24.4883 10.1389 24.0916 9.89511 23.7554H9.96119C8.88347 22.5967 8.9974 21.6487 10.1389 21.317H13.9143C14.3404 21.317 14.689 20.9741 14.689 20.555V17.2582C14.9533 15.008 15.9308 15.6759 17.0814 16.3729C19.8611 18.056 21.7089 14.0689 19.4624 12.704C17.6988 11.6327 16.9356 13.475 15.6437 13.2845C15.1447 13.2105 14.7984 12.6794 14.689 11.8725V8.61382C14.689 8.19471 14.3404 7.85181 13.9143 7.85181H10.6083C9.04296 7.65682 8.74677 6.62138 9.95891 5.31924H9.89283C10.1366 4.98305 10.2779 4.58636 10.2779 4.16053C10.2802 2.9682 9.18195 2 7.82627 2C6.47286 2 5.37464 2.9682 5.37464 4.16053C5.37464 4.58636 5.51591 4.98305 5.7597 5.31924H5.74375C6.9559 6.62138 6.66197 7.65906 5.09439 7.85181H1.77468C1.3486 7.85181 1 8.19471 1 8.61382V12.0115C1.24835 13.41 2.27366 13.6386 3.5496 12.4889V12.5046C3.89137 12.2648 4.29465 12.1258 4.72756 12.1258C5.9397 12.1258 6.924 13.2061 6.924 14.5373C6.924 15.8686 5.9397 16.9489 4.72756 16.9489C4.29465 16.9489 3.89137 16.8099 3.5496 16.5701V16.6351C2.27366 15.4854 1.24835 15.7162 1 17.1147V20.5572C1 20.9763 1.3486 21.3192 1.77468 21.3192H5.56376C6.70527 21.6509 6.82147 22.599 5.74148 23.7577H5.75743C5.51591 24.0939 5.37237 24.4906 5.37237 24.9164C5.37464 26.1087 6.47286 27.0769 7.82627 27.0747ZM22.1715 27.1979H22.1669C20.8135 27.1979 19.713 26.2297 19.713 25.0374C19.713 24.6116 19.8543 24.2149 20.0981 23.8787H20.0821C21.1598 22.72 21.0459 21.772 19.9044 21.4403H16.1153C15.6892 21.4403 15.3406 21.0974 15.3406 20.6783V17.2425C15.5229 16.7225 15.7553 16.5387 16.0287 16.532C16.154 16.5298 16.2862 16.5634 16.4275 16.6217C16.8239 16.783 17.2887 17.1215 17.7945 17.3142C19.7449 18.0538 21.4196 16.1869 21.3079 14.2684C21.2829 13.8403 21.1074 13.419 20.8477 13.029C19.852 11.5319 18.3778 11.3907 16.9561 12.2446C16.2315 12.6816 15.6551 13.0111 15.3247 11.9824L15.3429 8.73484C15.3452 8.31574 15.6915 7.97283 16.1176 7.97283H19.435C21.0003 7.77784 21.2965 6.7424 20.0844 5.44026H20.1003C19.8565 5.10408 19.7153 4.70738 19.7153 4.28155C19.7153 3.08923 20.8135 2.12103 22.1692 2.12103H22.1737C23.5271 2.12103 24.6276 3.08923 24.6276 4.28155C24.6276 4.70738 24.4864 5.10408 24.2426 5.44026H24.2585C23.0464 6.7424 23.3403 7.78009 24.9079 7.97283H28.2253C28.6514 7.97283 29 8.31574 29 8.73484V12.1325C28.7516 13.531 27.7263 13.7596 26.4504 12.6099V12.6256C26.1086 12.3858 25.7053 12.2468 25.2724 12.2468C24.0603 12.2468 23.076 13.3271 23.076 14.6584C23.076 15.9896 24.0603 17.0722 25.2724 17.0722C25.7053 17.0722 26.1086 16.9332 26.4504 16.6934V16.7584C27.7286 15.6086 28.7516 15.8395 29 17.238V20.6738C29 21.0929 28.6514 21.4358 28.2253 21.4358H24.4362C23.2947 21.7675 23.1808 22.7155 24.2585 23.8742H24.2403C24.4841 24.2104 24.6254 24.6071 24.6254 25.0329C24.6231 26.2297 23.5249 27.1979 22.1715 27.1979Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Integração</span>
        </a>
      </li>
      <!--
      <li *ngIf="!isSafeGis && isGpaUser">
        <a routerLink="/processos" routerLinkActive="active" ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }">
          <span class="icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.6667 16H18.6667V18.6667H10.6667V16ZM8 5.33333H5.33333V8H8V5.33333ZM10.6667 13.3333H18.6667V10.6667H10.6667V13.3333ZM10.6667 8H18.6667V5.33333H10.6667V8ZM8 10.6667H5.33333V13.3333H8V10.6667ZM24 2.66667V21.3333C24 22.8 22.8 24 21.3333 24H2.66667C1.2 24 0 22.8 0 21.3333V2.66667C0 1.2 1.2 0 2.66667 0H21.3333C22.8 0 24 1.2 24 2.66667ZM21.3333 2.66667H2.66667V21.3333H21.3333V2.66667ZM8 16H5.33333V18.6667H8V16Z"
                fill="white" />
            </svg>
          </span>
          <span class="item">Processos</span>
        </a>
      </li>

      <!-- Menu Usuário Fornecedor -->
      <!-- <li *ngIf="!isSafeGis && isGpaUserProvider">
        <div
          class="arrow"
          (click)="toggleArrowSide()"
          [ngStyle]="{ left: isSidebarPinned ? '22px' : '208px' }"
        >
          <svg
            [style.transform]="rotationArrow()"
            width="16"
            height="15"
            viewBox="0 0 16 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.8647 0.00176811C15.1295 0.0013113 15.3861 0.0826864 15.59 0.231768C15.7048 0.315717 15.7996 0.418818 15.8692 0.535166C15.9387 0.651513 15.9815 0.778819 15.9952 0.909796C16.0089 1.04077 15.9932 1.17284 15.9489 1.29845C15.9047 1.42405 15.8328 1.54072 15.7374 1.64177L10.6603 7.00177L15.556 12.3718C15.6502 12.4741 15.7205 12.5918 15.7629 12.7181C15.8053 12.8444 15.819 12.9769 15.8032 13.108C15.7874 13.239 15.7424 13.366 15.6708 13.4816C15.5992 13.5972 15.5025 13.6992 15.386 13.7818C15.2688 13.8728 15.1315 13.9415 14.9827 13.9835C14.834 14.0255 14.677 14.0399 14.5216 14.0258C14.3663 14.0117 14.2159 13.9694 14.0799 13.9016C13.9439 13.8338 13.8253 13.7419 13.7315 13.6318L8.2578 7.63177C8.09112 7.45284 8 7.22839 8 6.99677C8 6.76514 8.09112 6.5407 8.2578 6.36177L13.9241 0.361769C14.0378 0.240751 14.1822 0.145087 14.3457 0.0825386C14.5091 0.01999 14.6869 -0.0076828 14.8647 0.00176811Z"
              fill="url(#paint0_linear_341_122)"
            />
            <path
              d="M6.86474 0.00176811C7.12953 0.0013113 7.38614 0.0826864 7.59003 0.231768C7.70478 0.315717 7.79964 0.418818 7.86917 0.535166C7.93869 0.651513 7.98153 0.778819 7.99521 0.909796C8.0089 1.04077 7.99317 1.17284 7.94892 1.29845C7.90467 1.42405 7.83278 1.54072 7.73736 1.64177L2.66033 7.00177L7.55603 12.3718C7.65017 12.4741 7.72047 12.5918 7.76289 12.7181C7.80531 12.8444 7.81901 12.9769 7.80322 13.108C7.78742 13.239 7.74243 13.366 7.67084 13.4816C7.59925 13.5972 7.50246 13.6992 7.38604 13.7818C7.26879 13.8728 7.13147 13.9415 6.98272 13.9835C6.83396 14.0255 6.67698 14.0399 6.52162 14.0258C6.36625 14.0117 6.21587 13.9694 6.0799 13.9016C5.94392 13.8338 5.8253 13.7419 5.73147 13.6318L0.257804 7.63177C0.0911217 7.45284 0 7.22839 0 6.99677C0 6.76514 0.0911217 6.5407 0.257804 6.36177L5.92413 0.361769C6.03782 0.240751 6.18223 0.145087 6.34566 0.0825386C6.50909 0.01999 6.68692 -0.0076828 6.86474 0.00176811Z"
              fill="url(#paint1_linear_341_122)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_341_122"
                x1="15.8251"
                y1="0.20834"
                x2="0.690979"
                y2="14.7237"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#487513" />
                <stop offset="1" stop-color="#BADF69" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_341_122"
                x1="15.8251"
                y1="0.20834"
                x2="0.690979"
                y2="14.7237"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#487513" />
                <stop offset="1" stop-color="#BADF69" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </li> -->
      <li *ngIf="!isSafeGis && isGpaUserProvider && !isGpaGeomonitoringAdmin">
        <a
          routerLink="/minha-empresa/home"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="icon">
            <svg
              width="26"
              height="24"
              viewBox="0 0 26 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24.8809 11.8086L13.618 0.553933C13.5369 0.472678 13.4406 0.408214 13.3345 0.364231C13.2285 0.320247 13.1148 0.297607 13 0.297607C12.8852 0.297607 12.7716 0.320247 12.6655 0.364231C12.5595 0.408214 12.4632 0.472678 12.3821 0.553933L1.11917 11.8086C0.79104 12.1367 0.605103 12.5824 0.605103 13.0473C0.605103 14.0125 1.38987 14.7973 2.3551 14.7973H3.54182V22.8282C3.54182 23.3121 3.93284 23.7032 4.41682 23.7032H11.25V17.5782H14.3125V23.7032H21.5832C22.0672 23.7032 22.4582 23.3121 22.4582 22.8282V14.7973H23.6449C24.1098 14.7973 24.5555 14.6141 24.8836 14.2832C25.5645 13.5996 25.5645 12.4922 24.8809 11.8086Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Home</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUserProvider">
        <a routerLink="/minha-empresa/manuais" [routerLinkActive]="['active']">
          <span class="icon"
            ><svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.96556 10.4482H23.5173L28.4829 15.4138H2L6.96556 10.4482Z"
                fill="white"
              />
              <path
                d="M7.79313 12.1034H22.6897L26.8277 16.2413C26.8277 16.2413 26.4884 20.3793 25.89 20.3793H4.43648C3.93666 20.3793 3.65527 16.2413 3.65527 16.2413L7.79313 12.1034Z"
                fill="#001539"
              />
              <path
                d="M6.96556 3H23.5173C23.975 3 24.3449 3.37078 24.3449 3.82762V17.8966C24.3449 18.3534 23.975 18.7242 23.5173 18.7242H6.96556C6.50786 18.7242 6.13794 18.3534 6.13794 17.8966V3.82754C6.13794 3.37078 6.50786 3 6.96556 3Z"
                fill="white"
              />
              <path
                d="M9.44823 7.13791H21.0344C21.4921 7.13791 21.862 6.76713 21.862 6.31029C21.862 5.85345 21.4921 5.48267 21.0344 5.48267H9.44823C8.99053 5.48267 8.62061 5.85345 8.62061 6.31029C8.62061 6.76713 8.99062 7.13791 9.44823 7.13791ZM21.0345 8.79307H9.44823C8.99053 8.79307 8.62061 9.16385 8.62061 9.62069C8.62061 10.0775 8.99053 10.4483 9.44823 10.4483H21.0344C21.4921 10.4483 21.862 10.0784 21.862 9.62069C21.862 9.16299 21.4921 8.79307 21.0345 8.79307ZM21.0345 12.1034H9.44823C8.99053 12.1034 8.62061 12.4742 8.62061 12.931C8.62061 13.3878 8.99053 13.7586 9.44823 13.7586H21.0344C21.4921 13.7586 21.862 13.3878 21.862 12.931C21.862 12.4742 21.4921 12.1034 21.0345 12.1034Z"
                fill="#001539"
              />
              <path
                d="M20.2069 15.4138V17.069C20.2069 17.9834 19.4654 18.7241 18.5517 18.7241H11.931C11.0174 18.7241 10.2759 17.9827 10.2759 17.069V15.4138H2V25.3449C2 26.2585 2.74148 27 3.65516 27H26.8276C27.7413 27 28.4828 26.2585 28.4828 25.3449V15.4138H20.2069Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Manuais</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUserProvider">
        <a
          routerLink="/minha-empresa/meus-dados"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
          [ngStyle]="{ 'pointer-events': needUpdateData ? 'none' : 'all' }"
        >
          <span class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
            >
              <path
                d="M15 5C9.477 5 5 9.477 5 15C5 20.523 9.477 25 15 25C20.523 25 25 20.523 25 15C25 9.477 20.523 5 15 5Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 21C7 21 9.30701 18.2338 14.9995 18.2338C20.692 18.2338 23 21 23 21M14.9995 14.8318C15.823 14.8318 16.6127 14.5246 17.195 13.9778C17.7773 13.431 18.1045 12.6893 18.1045 11.9159C18.1045 11.1426 17.7773 10.4009 17.195 9.85405C16.6127 9.30721 15.823 9 14.9995 9C14.176 9 13.3862 9.30721 12.8039 9.85405C12.2216 10.4009 11.8945 11.1426 11.8945 11.9159C11.8945 12.6893 12.2216 13.431 12.8039 13.9778C13.3862 14.5246 14.176 14.8318 14.9995 14.8318V14.8318Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="item">Meus Dados</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUserProvider">
        <a
          routerLink="/minha-empresa/consulta-fornecedores"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
          [ngStyle]="{ 'pointer-events': needUpdateData ? 'none' : 'all' }"
        >
          <span class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
            >
              <path
                d="M10.215 5L8.42663 6.65039L9.5951 7.72444L11.378 6.07506L10.215 5ZM12.0747 6.72294L11.5316 7.22572L18.2791 13.4681L18.8222 12.9658L12.0747 6.72294ZM20.8191 7.6392C20.6161 7.6392 20.4131 7.64428 20.2211 7.65442C18.4711 7.74473 17.1107 8.25106 15.9257 8.9933L19.5189 12.3215C19.7109 12.6918 22.3716 17.2021 23.1121 18.577C22.58 18.2523 16.3427 15.259 16.3427 15.259L15.5033 14.4878V21.6059C16.8144 20.8651 18.2517 20.2005 20.0895 20.023C22.1466 19.82 24.6701 20.2411 28 21.7023V9.35352C25.1638 8.18713 22.8817 7.68486 21.022 7.64428C20.9507 7.64428 20.8849 7.6387 20.8191 7.6392ZM8.15782 7.69146C6.46271 7.84315 4.43515 8.35405 2 9.35352V21.7023C5.33537 20.2411 7.8561 19.82 9.91328 20.023C11.7236 20.2868 13.1005 20.8246 14.4994 21.6059V13.5594C12.3819 11.6061 10.2699 9.64778 8.15782 7.69146ZM10.8349 7.87157L10.2918 8.37333L17.0394 14.6147L17.5824 14.1124L10.8349 7.87157ZM19.3873 13.737L17.8787 15.1322L20.9014 16.5324L19.3873 13.737ZM8.84355 20.921C7.08809 20.9362 4.90199 21.4182 2 22.7474V24.9036C5.33537 23.4425 7.8561 23.0214 9.91328 23.2243C10.9336 23.3258 11.8278 23.5744 12.6452 23.8991C12.3874 24.2085 12.135 24.5738 11.8827 25H18.3121C17.9829 24.584 17.6647 24.2187 17.3411 23.9041C18.1639 23.5744 19.0636 23.3258 20.0895 23.2243C22.1466 23.0214 24.6701 23.4425 28 24.9036V22.7474C25.087 21.4131 22.8927 20.926 21.1318 20.921H20.9617C20.6984 20.926 20.446 20.9412 20.1992 20.9666C18.334 21.1493 16.9296 21.8798 15.5033 22.7119C15.1906 22.6713 14.7902 22.6206 14.4994 22.6662C13.0073 21.8443 11.3067 21.1239 9.80905 20.9666C9.50185 20.9362 9.17818 20.921 8.84355 20.921Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Meus Fornecedores</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUserProvider">
        <a
          routerLink="/minha-empresa/consulta-clientes"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
          [ngStyle]="{ 'pointer-events': needUpdateData ? 'none' : 'all' }"
        >
          <span class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
            >
              <path
                d="M10.215 5L8.42663 6.65039L9.5951 7.72444L11.378 6.07506L10.215 5ZM12.0747 6.72294L11.5316 7.22572L18.2791 13.4681L18.8222 12.9658L12.0747 6.72294ZM20.8191 7.6392C20.6161 7.6392 20.4131 7.64428 20.2211 7.65442C18.4711 7.74473 17.1107 8.25106 15.9257 8.9933L19.5189 12.3215C19.7109 12.6918 22.3716 17.2021 23.1121 18.577C22.58 18.2523 16.3427 15.259 16.3427 15.259L15.5033 14.4878V21.6059C16.8144 20.8651 18.2517 20.2005 20.0895 20.023C22.1466 19.82 24.6701 20.2411 28 21.7023V9.35352C25.1638 8.18713 22.8817 7.68486 21.022 7.64428C20.9507 7.64428 20.8849 7.6387 20.8191 7.6392ZM8.15782 7.69146C6.46271 7.84315 4.43515 8.35405 2 9.35352V21.7023C5.33537 20.2411 7.8561 19.82 9.91328 20.023C11.7236 20.2868 13.1005 20.8246 14.4994 21.6059V13.5594C12.3819 11.6061 10.2699 9.64778 8.15782 7.69146ZM10.8349 7.87157L10.2918 8.37333L17.0394 14.6147L17.5824 14.1124L10.8349 7.87157ZM19.3873 13.737L17.8787 15.1322L20.9014 16.5324L19.3873 13.737ZM8.84355 20.921C7.08809 20.9362 4.90199 21.4182 2 22.7474V24.9036C5.33537 23.4425 7.8561 23.0214 9.91328 23.2243C10.9336 23.3258 11.8278 23.5744 12.6452 23.8991C12.3874 24.2085 12.135 24.5738 11.8827 25H18.3121C17.9829 24.584 17.6647 24.2187 17.3411 23.9041C18.1639 23.5744 19.0636 23.3258 20.0895 23.2243C22.1466 23.0214 24.6701 23.4425 28 24.9036V22.7474C25.087 21.4131 22.8927 20.926 21.1318 20.921H20.9617C20.6984 20.926 20.446 20.9412 20.1992 20.9666C18.334 21.1493 16.9296 21.8798 15.5033 22.7119C15.1906 22.6713 14.7902 22.6206 14.4994 22.6662C13.0073 21.8443 11.3067 21.1239 9.80905 20.9666C9.50185 20.9362 9.17818 20.921 8.84355 20.921Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Meus Clientes</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUserProvider">
        <a
          routerLink="/minha-empresa/produtos"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
          [ngStyle]="{ 'pointer-events': needUpdateData ? 'none' : 'all' }"
        >
          <span class="icon">
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25 7L13 1L1 7V19L13 25L25 19V7Z"
                stroke="white"
                stroke-width="2"
                stroke-linejoin="round"
              />
              <path
                d="M1 7L13 13M13 25V13M25 7L13 13M19 4L7 10"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="item">Produtos</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUserProvider">
        <a
          routerLink="/minha-empresa/contatos"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
          [ngStyle]="{ 'pointer-events': needUpdateData ? 'none' : 'all' }"
        >
          <span class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
            >
              <path
                d="M15 15C13.4875 15 12.1927 14.4615 11.1156 13.3844C10.0385 12.3073 9.5 11.0125 9.5 9.5C9.5 7.9875 10.0385 6.69271 11.1156 5.61563C12.1927 4.53854 13.4875 4 15 4C16.5125 4 17.8073 4.53854 18.8844 5.61563C19.9615 6.69271 20.5 7.9875 20.5 9.5C20.5 11.0125 19.9615 12.3073 18.8844 13.3844C17.8073 14.4615 16.5125 15 15 15ZM4 26V22.15C4 21.3708 4.20075 20.6545 4.60225 20.0009C5.00283 19.3482 5.53542 18.85 6.2 18.5063C7.62083 17.7958 9.06458 17.2628 10.5312 16.9071C11.9979 16.5524 13.4875 16.375 15 16.375C16.5125 16.375 18.0021 16.5524 19.4688 16.9071C20.9354 17.2628 22.3792 17.7958 23.8 18.5063C24.4646 18.85 24.9972 19.3482 25.3978 20.0009C25.7992 20.6545 26 21.3708 26 22.15V26H4Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Contatos</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUserProvider">
        <a routerLink="/minha-empresa/ranking">
          <span class="icon"
            ><svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.26434 12.0436C1.26434 11.8204 1.31893 11.5918 1.42801 11.4302C1.53708 11.2685 1.68688 11.1903 1.87741 11.1903C2.09049 11.1903 2.25034 11.2543 2.35698 11.3795C2.46347 11.505 2.51684 11.6737 2.51684 11.8842C2.51684 12.0321 2.46413 12.2067 2.35891 12.4073C2.25364 12.6079 2.06891 12.8362 1.84567 13.0919L0.0650106 14.9424V15.7273H3.86033V14.8343H1.80216L1.79078 14.7905L2.53177 13.9864C3.01322 13.4625 3.34339 13.0622 3.5228 12.7964C3.70195 12.5306 3.79158 12.2221 3.79158 11.8762C3.79158 11.3622 3.62289 10.956 3.28581 10.66C2.94857 10.3643 2.47906 10.2157 1.87741 10.2157C1.31081 10.2157 0.855712 10.3915 0.512233 10.7437C0.168755 11.0959 0.00321093 11.5198 0.0158045 12.0263L0.0233707 12.0435H1.26434V12.0436Z"
                fill="white"
              />
              <path
                d="M1.29281 6.46237H0.0649414V7.46701H3.86027V6.46237H2.63235V1.93164L0.0649414 2.31524V3.22517H1.29281V6.46237Z"
                fill="white"
              />
              <path
                d="M3.01674 21.1825C3.27491 21.0647 3.48123 20.9011 3.6354 20.6918C3.78967 20.4825 3.8667 20.2536 3.8667 20.0055C3.8667 19.5066 3.68867 19.1211 3.3327 18.8491C2.97672 18.5769 2.50162 18.441 1.90734 18.441C1.39588 18.441 0.960846 18.5764 0.602337 18.8472C0.243827 19.118 0.0718851 19.4911 0.0869668 19.9273L0.0945331 19.9694H1.32814C1.32814 19.7461 1.39065 19.6766 1.51613 19.5813C1.64151 19.4859 1.78694 19.4287 1.95238 19.4287C2.16302 19.4287 2.32344 19.4827 2.43383 19.6006C2.54413 19.7184 2.59927 19.8613 2.59927 20.0343C2.59927 20.2524 2.53788 20.4333 2.41509 20.5562C2.29221 20.6791 2.11671 20.7507 1.88855 20.7507H1.29275V21.6438H1.8885C2.14179 21.6438 2.33791 21.7186 2.4771 21.8401C2.61629 21.9618 2.68585 22.1625 2.68585 22.4282C2.68585 22.6188 2.61933 22.7802 2.48659 22.9056C2.35365 23.031 2.17561 23.0953 1.95243 23.0953C1.75688 23.0953 1.59088 23.011 1.45413 22.892C1.31737 22.773 1.24918 22.6484 1.24918 22.4252H0.00805416L0.000589445 22.4734C-0.0119025 22.9849 0.174157 23.3883 0.559072 23.6578C0.943987 23.9272 1.39339 24.0684 1.90729 24.0684C2.50406 24.0684 2.99419 23.9282 3.37784 23.6411C3.76148 23.3541 3.95318 22.9613 3.95318 22.4598C3.95318 22.154 3.87056 21.8922 3.70502 21.6728C3.53947 21.4532 3.3101 21.2904 3.01674 21.1825Z"
                fill="white"
              />
              <path
                d="M25.9618 18.4062H7.54346V22.0899H25.9618V18.4062Z"
                fill="white"
              />
              <path
                d="M25.9618 11.1505H7.54346V14.8342H25.9618V11.1505Z"
                fill="white"
              />
              <path
                d="M25.9618 3.67163H7.54346V7.35529H25.9618V3.67163Z"
                fill="white"
              />
              <path
                d="M26.0002 18.4062H13.1631V22.0899H26.0002V18.4062Z"
                fill="white"
              />
              <path
                d="M26.0002 11.1505H13.1631V14.8342H26.0002V11.1505Z"
                fill="white"
              />
              <path
                d="M26.0002 3.67163H13.1631V7.35529H26.0002V3.67163Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Ranking</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUserProvider">
        <a
          routerLink="/minha-empresa/integracao"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
          [ngStyle]="{ 'pointer-events': needUpdateData ? 'none' : 'all' }"
        >
          <span class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.82627 27.0747C9.17967 27.0747 10.2802 26.1065 10.2802 24.9142C10.2802 24.4883 10.1389 24.0916 9.89511 23.7554H9.96119C8.88347 22.5967 8.9974 21.6487 10.1389 21.317H13.9143C14.3404 21.317 14.689 20.9741 14.689 20.555V17.2582C14.9533 15.008 15.9308 15.6759 17.0814 16.3729C19.8611 18.056 21.7089 14.0689 19.4624 12.704C17.6988 11.6327 16.9356 13.475 15.6437 13.2845C15.1447 13.2105 14.7984 12.6794 14.689 11.8725V8.61382C14.689 8.19471 14.3404 7.85181 13.9143 7.85181H10.6083C9.04296 7.65682 8.74677 6.62138 9.95891 5.31924H9.89283C10.1366 4.98305 10.2779 4.58636 10.2779 4.16053C10.2802 2.9682 9.18195 2 7.82627 2C6.47286 2 5.37464 2.9682 5.37464 4.16053C5.37464 4.58636 5.51591 4.98305 5.7597 5.31924H5.74375C6.9559 6.62138 6.66197 7.65906 5.09439 7.85181H1.77468C1.3486 7.85181 1 8.19471 1 8.61382V12.0115C1.24835 13.41 2.27366 13.6386 3.5496 12.4889V12.5046C3.89137 12.2648 4.29465 12.1258 4.72756 12.1258C5.9397 12.1258 6.924 13.2061 6.924 14.5373C6.924 15.8686 5.9397 16.9489 4.72756 16.9489C4.29465 16.9489 3.89137 16.8099 3.5496 16.5701V16.6351C2.27366 15.4854 1.24835 15.7162 1 17.1147V20.5572C1 20.9763 1.3486 21.3192 1.77468 21.3192H5.56376C6.70527 21.6509 6.82147 22.599 5.74148 23.7577H5.75743C5.51591 24.0939 5.37237 24.4906 5.37237 24.9164C5.37464 26.1087 6.47286 27.0769 7.82627 27.0747ZM22.1715 27.1979H22.1669C20.8135 27.1979 19.713 26.2297 19.713 25.0374C19.713 24.6116 19.8543 24.2149 20.0981 23.8787H20.0821C21.1598 22.72 21.0459 21.772 19.9044 21.4403H16.1153C15.6892 21.4403 15.3406 21.0974 15.3406 20.6783V17.2425C15.5229 16.7225 15.7553 16.5387 16.0287 16.532C16.154 16.5298 16.2862 16.5634 16.4275 16.6217C16.8239 16.783 17.2887 17.1215 17.7945 17.3142C19.7449 18.0538 21.4196 16.1869 21.3079 14.2684C21.2829 13.8403 21.1074 13.419 20.8477 13.029C19.852 11.5319 18.3778 11.3907 16.9561 12.2446C16.2315 12.6816 15.6551 13.0111 15.3247 11.9824L15.3429 8.73484C15.3452 8.31574 15.6915 7.97283 16.1176 7.97283H19.435C21.0003 7.77784 21.2965 6.7424 20.0844 5.44026H20.1003C19.8565 5.10408 19.7153 4.70738 19.7153 4.28155C19.7153 3.08923 20.8135 2.12103 22.1692 2.12103H22.1737C23.5271 2.12103 24.6276 3.08923 24.6276 4.28155C24.6276 4.70738 24.4864 5.10408 24.2426 5.44026H24.2585C23.0464 6.7424 23.3403 7.78009 24.9079 7.97283H28.2253C28.6514 7.97283 29 8.31574 29 8.73484V12.1325C28.7516 13.531 27.7263 13.7596 26.4504 12.6099V12.6256C26.1086 12.3858 25.7053 12.2468 25.2724 12.2468C24.0603 12.2468 23.076 13.3271 23.076 14.6584C23.076 15.9896 24.0603 17.0722 25.2724 17.0722C25.7053 17.0722 26.1086 16.9332 26.4504 16.6934V16.7584C27.7286 15.6086 28.7516 15.8395 29 17.238V20.6738C29 21.0929 28.6514 21.4358 28.2253 21.4358H24.4362C23.2947 21.7675 23.1808 22.7155 24.2585 23.8742H24.2403C24.4841 24.2104 24.6254 24.6071 24.6254 25.0329C24.6231 26.2297 23.5249 27.1979 22.1715 27.1979Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Integração</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUserProvider">
        <a
          routerLink="/minha-empresa/expedicao"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
          [ngStyle]="{ 'pointer-events': needUpdateData ? 'none' : 'all' }"
        >
          <span class="icon">
            <svg
              width="30"
              height="30"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.1579 36C9.28947 36 8.54632 35.6869 7.92842 35.0608C7.30947 34.4336 7 33.68 7 32.8V7.2C7 6.32 7.30947 5.5664 7.92842 4.9392C8.54632 4.31307 9.28947 4 10.1579 4H22.7895L32.2632 13.6V18.56L19.6316 31.32V36H10.1579ZM22.7895 36V32.6L30.9211 24.32L34.3158 27.68L26.1447 36H22.7895ZM35.4605 26.56L32.1053 23.16L33.2105 22.04C33.5263 21.72 33.9079 21.56 34.3553 21.56C34.8026 21.56 35.1711 21.72 35.4605 22.04L36.5658 23.2C36.8553 23.52 37 23.8997 37 24.3392C37 24.7797 36.8553 25.1467 36.5658 25.44L35.4605 26.56ZM21.2105 15.2H29.1053L21.2105 7.2V15.2Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Expedição</span>
        </a>
      </li>
      <li *ngIf="!isSafeGis && isGpaUserProvider">
        <a
          routerLink="/minha-empresa/recebimento"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
          [ngStyle]="{ 'pointer-events': needUpdateData ? 'none' : 'all' }"
        >
          <span class="icon">
            <svg
              width="28"
              height="28"
              viewBox="0 0 44 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M42.5 32.2105V17.1052H1.5V40.8421C1.5 41.4144 1.72735 41.9632 2.13203 42.3679C2.53672 42.7726 3.08559 43 3.65789 43H22"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.5 7.39471C1.5 6.8224 1.72735 6.27353 2.13203 5.86885C2.53672 5.46417 3.08559 5.23682 3.65789 5.23682H40.3421C40.9144 5.23682 41.4633 5.46417 41.868 5.86885C42.2727 6.27353 42.5 6.8224 42.5 7.39471V17.1052H1.5V7.39471Z"
                stroke="white"
                stroke-width="3"
                stroke-linejoin="round"
              />
              <path
                d="M13.3682 2V10.6316M30.6313 2V10.6316"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
              />
              <path
                d="M28.474 38.6842C32.6452 38.6842 36.0267 35.3028 36.0267 31.1316C36.0267 26.9604 32.6452 23.579 28.474 23.579C24.3028 23.579 20.9214 26.9604 20.9214 31.1316C20.9214 35.3028 24.3028 38.6842 28.474 38.6842Z"
                stroke="white"
                stroke-width="3"
              />
              <path
                d="M34.9473 36.5264L41.421 41.9211"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="item">Recebimento</span>
        </a>
      </li>

      <!-- Menu Safe Gis -->
      <li *ngIf="isSafeGis">
        <a
          routerLink="/safe-gis/solicitacoes"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="icon">
            <svg
              width="26"
              height="26"
              viewBox="0 0 20 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15 4.66045e-09C15.7652 -4.26217e-05 16.5015 0.292325 17.0583 0.817284C17.615 1.34224 17.9501 2.06011 17.995 2.824L18 3V7.35L18.594 7.086C19.208 6.813 19.916 7.236 19.994 7.884L20 8V16C20.0002 16.5046 19.8096 16.9906 19.4665 17.3605C19.1234 17.7305 18.6532 17.9572 18.15 17.995L18 18H2C1.49542 18.0002 1.00943 17.8096 0.639452 17.4665C0.269471 17.1234 0.0428433 16.6532 0.00500011 16.15L0 16V8C0 7.328 0.675 6.853 1.297 7.045L1.407 7.086L2 7.35V3C1.99996 2.23479 2.29233 1.49849 2.81728 0.941739C3.34224 0.384993 4.06011 0.0498925 4.824 0.00500012L5 4.66045e-09H15ZM18 9.539L10.812 12.733C10.5564 12.8466 10.2797 12.9053 10 12.9053C9.72027 12.9053 9.44364 12.8466 9.188 12.733L2 9.54V16H18V9.539ZM15 2H5C4.73478 2 4.48043 2.10536 4.29289 2.29289C4.10536 2.48043 4 2.73478 4 3V8.239L10 10.906L16 8.239V3C16 2.73478 15.8946 2.48043 15.7071 2.29289C15.5196 2.10536 15.2652 2 15 2ZM10 5C10.2549 5.00028 10.5 5.09788 10.6854 5.27285C10.8707 5.44782 10.9822 5.68695 10.9972 5.94139C11.0121 6.19584 10.9293 6.44638 10.7657 6.64183C10.6021 6.83729 10.3701 6.9629 10.117 6.993L10 7H8C7.74512 6.99972 7.49997 6.90212 7.31463 6.72715C7.1293 6.55218 7.01776 6.31305 7.00283 6.05861C6.98789 5.80416 7.07067 5.55362 7.23426 5.35817C7.39785 5.16271 7.6299 5.0371 7.883 5.007L8 5H10Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="item">Solicitações</span>
        </a>
        <ul *ngIf="isSafeGisClient">
          <li>
            <a
              routerLink="/safe-gis/solicitacoes/novas-solicitacoes"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <span class="item">Novas Solicitações</span>
            </a>
          </li>
          <li>
            <a
              routerLink="/safe-gis/solicitacoes/solicitacoes-respondidas"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <span class="item"> Solicitações Respondidas</span>
            </a>
          </li>
          <li>
            <a
              routerLink="/safe-gis/solicitacoes/pendentes-informacao"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <span class="item"> Pendentes de Informação</span>
            </a>
          </li>
          <li>
            <a
              routerLink="/safe-gis/solicitacoes/mapa-de-sobreposicao"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <span class="item"> Mapa de sobreposição</span>
            </a>
          </li>
          <li>
            <a
              routerLink="/safe-gis/solicitacoes/analise-detalhada"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              [routerLinkActiveOptions]="{ exact: true }"
              *ngIf="isAdmin"
            >
              <span class="item"> Análise Detalhada </span>
            </a>
          </li>
          <li>
            <a (click)="redirectToGpa()" *ngIf="isAdminGpa">
              <span class="item"> Voltar para o GPA </span>
            </a>
          </li>
        </ul>
      </li>

      <li *ngIf="isSuperAdmin && !isNicePlanet">
        <a routerLink="/usuarios" routerLinkActive="active" ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }">
          <span class="material-icons" style="margin-left: 0.6%;">
            people
          </span> 
          <span class="item">Usuários</span>
        </a>
      </li>
      <!-- <li *ngIf="isSafeGis">
        <a routerLink="/safe-gis/pendentes" routerLinkActive="active" ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }">
          <span class="icon">
            <svg width="26" height="26" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 21C12.6167 21 11.4373 20.5123 10.462 19.537C9.48667 18.5617 8.99934 17.3827 9 16C9 14.6167 9.48767 13.4373 10.463 12.462C11.4383 11.4867 12.6173 10.9993 14 11C15.3833 11 16.5627 11.4877 17.538 12.463C18.5133 13.4383 19.0007 14.6173 19 16C19 17.3833 18.5123 18.5627 17.537 19.538C16.5617 20.5133 15.3827 21.0007 14 21ZM15.675 18.375L16.375 17.675L14.5 15.8V13H13.5V16.2L15.675 18.375ZM2 20C1.45 20 0.979002 19.804 0.587002 19.412C0.195002 19.02 -0.000664969 18.5493 1.69779e-06 18V4C1.69779e-06 3.45 0.196002 2.979 0.588002 2.587C0.980002 2.195 1.45067 1.99934 2 2H6.175C6.35834 1.41667 6.71667 0.937335 7.25 0.562002C7.78334 0.186668 8.36667 -0.000664894 9 1.77305e-06C9.66667 1.77305e-06 10.2627 0.187668 10.788 0.563002C11.3133 0.938335 11.6673 1.41734 11.85 2H16C16.55 2 17.021 2.196 17.413 2.588C17.805 2.98 18.0007 3.45067 18 4V10.25C17.7 10.0333 17.3833 9.85 17.05 9.7C16.7167 9.55 16.3667 9.41667 16 9.3V4H14V7H4V4H2V18H7.3C7.41667 18.3667 7.55 18.7167 7.7 19.05C7.85 19.3833 8.03334 19.7 8.25 20H2ZM9 4C9.28334 4 9.521 3.904 9.713 3.712C9.905 3.52 10.0007 3.28267 10 3C10 2.71667 9.904 2.479 9.712 2.287C9.52 2.095 9.28267 1.99934 9 2C8.71667 2 8.479 2.096 8.287 2.288C8.095 2.48 7.99934 2.71733 8 3C8 3.28333 8.096 3.521 8.288 3.713C8.48 3.905 8.71734 4.00067 9 4Z" fill="white"/>
            </svg>
          </span>
          <span class="item">Pendentes</span>
        </a>
      </li>

      <li *ngIf="isSafeGis">
        <a routerLink="/safe-gis/a-vencer" routerLinkActive="active" ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }">
          <span class="icon">
            <svg width="26" height="26" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V5C1 4.46957 1.21071 3.96086 1.58579 3.58579C1.96086 3.21071 2.46957 3 3 3H15C15.5304 3 16.0391 3.21071 16.4142 3.58579C16.7893 3.96086 17 4.46957 17 5V10M13 1V5M5 1V5M1 9H17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="item">A vencer</span>
        </a>
      </li>

      <li *ngIf="isSafeGis">
        <a routerLink="/safe-gis/vencidas" routerLinkActive="active" ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }">
          <span class="icon">
            <svg width="26" height="26" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.77189 3.21743L4.32389 1.76943C6.24824 0.441074 8.57742 -0.170542 10.9061 0.0410022C13.2348 0.252546 15.4157 1.27386 17.0692 2.92723C18.7227 4.5806 19.7441 6.76136 19.9558 9.09006C20.1675 11.4188 19.5561 13.748 18.2279 15.6724L16.7829 14.2274C17.7403 12.6953 18.1502 10.8839 17.9457 9.08883C17.7412 7.29377 16.9343 5.621 15.6568 4.34348C14.3793 3.06596 12.7065 2.25912 10.9115 2.05462C9.11641 1.85011 7.30402 2.26001 5.77189 3.21743ZM18.3599 18.3664L17.0809 19.6454L15.6679 18.2314C13.7435 19.558 11.4151 20.1682 9.08749 19.956C6.75986 19.7438 4.5802 18.7225 2.92748 17.0698C1.27477 15.4171 0.253522 13.2375 0.041301 10.9098C-0.170919 8.58218 0.439308 6.25378 1.76589 4.32943L0.355887 2.91943L1.63389 1.63943L2.92389 2.93143L4.34089 4.34443L8.99789 9.00443V5.00243H10.4979V10.2524L14.9979 12.9224L14.2479 14.1524L13.9939 14.0004L18.3599 18.3664ZM14.2239 16.7864L8.43089 10.9944L3.21289 5.77643C2.25547 7.30856 1.84557 9.11995 2.05008 10.915C2.25458 12.7101 3.06142 14.3829 4.33894 15.6604C5.61646 16.9379 7.28923 17.7447 9.08429 17.9492C10.8794 18.1537 12.6918 17.7438 14.2239 16.7864Z" fill="white"/>
            </svg>
          </span>
          <span class="item">Vencidas</span>
        </a>
      </li>

      <li *ngIf="isSafeGis">
        <a routerLink="/safe-gis/analises" routerLinkActive="active" ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }">
          <span class="icon">
            <svg width="26" height="26" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.8069 13.4616L22.8043 13.4591L22.8017 13.4565C21.6742 11.071 19.9279 9.84375 17.6037 9.84375C15.2795 9.84375 13.5332 11.0736 12.4031 13.4565V13.4591C12.265 13.7531 12.265 14.0957 12.4031 14.3898C13.5332 16.7727 15.2795 18 17.6037 18C19.9279 18 21.6742 16.7702 22.8043 14.3872C22.9424 14.0932 22.9424 13.7531 22.8069 13.4616ZM17.6037 16.3636C16.0159 16.3636 14.8577 15.5966 13.996 13.9219C14.8551 12.2472 16.0159 11.4801 17.6037 11.4801C19.1915 11.4801 20.3497 12.2472 21.2114 13.9219C20.3523 15.5966 19.1915 16.3636 17.6037 16.3636Z" fill="white"/>
              <path d="M16.1847 13.9347C16.1847 14.3144 16.3356 14.6786 16.6041 14.9471C16.8726 15.2156 17.2368 15.3665 17.6166 15.3665C17.9963 15.3665 18.3605 15.2156 18.629 14.9471C18.8975 14.6786 19.0484 14.3144 19.0484 13.9347C19.0484 13.5549 18.8975 13.1907 18.629 12.9222C18.3605 12.6537 17.9963 12.5028 17.6166 12.5028C17.2368 12.5028 16.8726 12.6537 16.6041 12.9222C16.3356 13.1907 16.1847 13.5549 16.1847 13.9347ZM1.84092 1.84091H19.841V8.30966H21.6819V0.818182C21.6819 0.365625 21.3163 0 20.8637 0H0.818186C0.365627 0 0 0.365625 0 0.818182V14.1136C0 14.5662 0.365627 14.9318 0.818186 14.9318H9.81823V13.0909H1.84092V1.84091Z" fill="white"/>
              <path d="M16.898 4.55369L15.9571 3.61278C15.8778 3.53352 15.7474 3.53352 15.6682 3.61278L10.9687 8.31733L8.7673 6.11335C8.68804 6.03409 8.55764 6.03409 8.47838 6.11335L4.78888 9.80284C4.70962 9.8821 4.70962 10.0125 4.78888 10.0918L5.72979 11.0327C5.80905 11.1119 5.93945 11.1119 6.01871 11.0327L8.62157 8.42983L10.823 10.6338C10.9023 10.7131 11.0327 10.7131 11.1119 10.6338L16.898 4.84261C16.9798 4.76335 16.9798 4.63295 16.898 4.55369Z" fill="white"/>
            </svg>
          </span>
          <span class="item">Análises</span>
        </a>
      </li>

      <li *ngIf="isSafeGis">
        <a routerLink="/safe-gis/produtores" routerLinkActive="active" ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }">
          <span class="icon">
            <svg width="26" height="26" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.4375 0L22 3.78125V12.2139L20.625 11.5264V5.31738L15.125 8.06738V10.8389L13.75 11.5264V8.06738L8.25 5.31738V7.75586L6.875 7.06836V3.78125L14.4375 0ZM14.4375 6.875L16.3389 5.91895L11.3652 3.07227L9.09863 4.21094L14.4375 6.875ZM17.8213 5.18848L19.7764 4.21094L14.4375 1.53613L12.8369 2.3418L17.8213 5.18848ZM12.375 12.2139L11 12.9014V12.8906L6.875 14.9531V19.8408L11 17.7676V19.3145L6.1875 21.7207L0 18.6162V11.3545L6.1875 8.26074L12.375 11.3545V12.2139ZM5.5 19.8408V14.9531L1.375 12.8906V17.7676L5.5 19.8408ZM6.1875 13.7607L10.1514 11.7842L6.1875 9.79688L2.22363 11.7842L6.1875 13.7607ZM12.375 13.75L17.1875 11.3438L22 13.75V19.4111L17.1875 21.8174L12.375 19.4111V13.75ZM16.5 19.9375V16.6611L13.75 15.2861V18.5625L16.5 19.9375ZM20.625 18.5625V15.2861L17.875 16.6611V19.9375L20.625 18.5625ZM17.1875 15.4688L19.7764 14.1689L17.1875 12.8799L14.5986 14.1689L17.1875 15.4688Z" fill="white"/>
            </svg>
          </span>
          <span class="item">Produtores</span>
        </a>
      </li>
      <li *ngIf="isSafeGis">
        <a routerLink="/safe-gis/clientes" routerLinkActive="active" ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: true }">
          <span class="icon">
            <svg width="26" height="26" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.0188 13.843C14.2552 13.1144 14.4917 12.3667 14.7474 11.6317C15.0413 10.7945 15.9744 10.411 16.7605 10.8009C17.144 10.9926 17.3932 11.3058 17.5211 11.7084C17.7256 12.3475 17.9429 12.9802 18.1346 13.6193C18.1921 13.7983 18.256 13.8686 18.4606 13.8686C19.1316 13.8494 19.8027 13.8622 20.4737 13.8622C21.1704 13.8622 21.7264 14.2457 21.9245 14.8656C22.129 15.4855 21.9117 16.1182 21.3493 16.5337C20.7997 16.9427 20.2437 17.3453 19.6812 17.7416C19.5534 17.831 19.5279 17.9013 19.579 18.0547C19.8027 18.7066 20.0072 19.3585 20.2181 20.0104C20.429 20.6815 20.2437 21.3142 19.7132 21.6976C19.1827 22.0875 18.5117 22.0683 17.9301 21.6529C17.3293 21.2183 16.7286 20.7837 16.1214 20.3427C15.4823 20.8029 14.856 21.2758 14.2169 21.7168C13.4819 22.2281 12.4849 21.9724 12.0887 21.18C11.9097 20.8284 11.8778 20.4642 11.9992 20.0871C12.2165 19.4224 12.421 18.7514 12.6511 18.0867C12.715 17.9013 12.6703 17.8183 12.5233 17.716C11.9417 17.307 11.3665 16.8916 10.7977 16.4634C10.3503 16.1182 10.165 15.6453 10.2544 15.0893C10.3503 14.5141 10.6954 14.1242 11.2515 13.9453C11.4176 13.8942 11.5966 13.875 11.7691 13.875C12.4977 13.8686 13.2199 13.8686 13.9485 13.8686C13.9676 13.8622 13.9804 13.8558 14.0188 13.843ZM12.0184 15.3961C12.012 15.4152 12.012 15.4344 12.0056 15.4472C12.6639 15.9265 13.3222 16.3994 13.9804 16.8788C14.3639 17.16 14.4598 17.4476 14.3128 17.9013C14.0955 18.5788 13.8718 19.2499 13.6545 19.9273C13.6225 20.036 13.5906 20.1446 13.5458 20.298C14.2552 19.7803 14.9199 19.301 15.5846 18.8153C15.968 18.5404 16.2556 18.5405 16.6391 18.8089C17.0737 19.122 17.5019 19.4352 17.9365 19.7547C18.173 19.9273 18.4094 20.0935 18.6842 20.2916C18.6459 20.1638 18.6267 20.0871 18.6012 20.0104C18.3711 19.2946 18.1346 18.5852 17.9045 17.8694C17.7703 17.4412 17.8662 17.1536 18.2305 16.8852C18.8504 16.4314 19.4703 15.984 20.0903 15.5303C20.135 15.4983 20.1797 15.4536 20.2628 15.3833C20.1286 15.3833 20.0519 15.3833 19.9752 15.3833C19.2339 15.3833 18.4861 15.3833 17.7448 15.3833C17.2846 15.3833 17.0417 15.2043 16.8948 14.7633C16.6647 14.0667 16.441 13.3701 16.2173 12.6671C16.1917 12.584 16.1534 12.5009 16.1086 12.3667C15.8338 13.2103 15.5718 13.9964 15.3225 14.7825C15.2267 15.0829 15.0477 15.2874 14.741 15.3577C14.6323 15.3833 14.5173 15.3769 14.4086 15.3769C13.6097 15.3961 12.8109 15.3961 12.0184 15.3961Z" fill="white"/>
              <path d="M10.4781 11.2355C7.36566 11.2291 4.85397 8.71103 4.86036 5.61137C4.86036 2.50532 7.38483 -0.00636362 10.4909 2.74284e-05C13.5969 0.00641848 16.1214 2.52449 16.115 5.62415C16.1086 8.72381 13.5841 11.2419 10.4781 11.2355ZM10.4973 9.70164C12.7533 9.69525 14.5812 7.8738 14.5875 5.61776C14.5939 3.36172 12.7469 1.5211 10.4845 1.52749C8.21567 1.53388 6.39421 3.36172 6.40061 5.63054C6.40061 7.88658 8.24123 9.70803 10.4973 9.70164Z" fill="white"/>
              <path d="M6.06191 20.9627C4.66227 20.9627 3.26263 20.9627 1.86938 20.9627C0.731777 20.9627 0.00958541 20.2469 0.00958541 19.1093C0.00958541 18.4957 -0.0287586 17.8758 0.0479341 17.2686C0.182146 16.1885 0.814859 15.3769 1.62013 14.693C2.67465 13.7983 3.91452 13.2551 5.22469 12.8588C6.9311 12.3411 8.68863 12.1111 10.4717 12.1238C10.9063 12.1238 11.2323 12.4306 11.2451 12.8396C11.2642 13.2678 10.9702 13.6002 10.5293 13.6513C10.4334 13.6641 10.3375 13.6577 10.2417 13.6577C8.77811 13.6641 7.34012 13.8494 5.93409 14.2457C4.73257 14.5844 3.59497 15.0573 2.61714 15.8498C2.11224 16.2588 1.67126 16.7382 1.569 17.4028C1.50509 17.8247 1.53066 18.2656 1.53066 18.6938C1.53066 19.5247 1.43479 19.4224 2.25285 19.4224C4.9307 19.4224 7.60855 19.4224 10.28 19.4224C10.3823 19.4224 10.4909 19.4224 10.5932 19.4416C11.0022 19.5119 11.2642 19.8506 11.2323 20.266C11.2067 20.6559 10.8872 20.9563 10.4781 20.9563C9.30857 20.9627 8.14539 20.9563 6.97583 20.9563C6.68184 20.9627 6.37507 20.9627 6.06191 20.9627Z" fill="white"/>
            </svg>
          </span>
          <span class="item">Clientes</span>
        </a>
      </li> -->

      
    </ul>
  </nav>
  <img
    src='../../../assets/images/logo-assai.png'
    alt=""
    class="nav-image"
  />
</aside>